import {getResizedImageUrl} from '@wix/music-shared/dist/src/utils/media/media';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {container} from '../../ioc/container';
import {services} from '../../ioc/services';
import {BI_ERRORS} from '../../services/biErrorLogger/biErrors';
import {errorLogger} from '../../services/errorLogger/errorLogger';
import {IImageUtils} from '../../services/injectable/ImageUtils/IImageUtils';
import {Loading} from '../Loading/Loading';
import styles from './Cover.scss';

export interface IProps {
  src?: string;
  accName?: string;
  children: React.ReactNode;
}

interface IState {
  isLoading: boolean;
  isError: boolean;
  isFailed?: boolean;
}
export class Cover extends React.Component<IProps, IState> {
  static propTypes = {
    src: PropTypes.string,
    accName: PropTypes.string,
    children: PropTypes.element,
  };

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isError: false,
    };
  }

  get coverSrc() {
    const {src} = this.props;
    if (!src) {
      return;
    }
    return getResizedImageUrl(src, 1200, 1200);
  }

  get isDummy() {
    const {src} = this.props;
    return !src;
  }

  componentDidMount() {
    const {src} = this.props;
    if (this.isDummy) {
      this.setState({
        isLoading: false,
        isFailed: false,
      });
      return;
    }
    const {coverSrc} = this;
    if (!coverSrc) {
      return;
    }
    const imageUtils = container.get<IImageUtils>(services.imageUtils);
    imageUtils
      .loadImage(coverSrc)
      .then(() => {
        this.setState({
          isLoading: false,
        });
      })
      .catch((reason) => {
        errorLogger.logError(
          {
            bi: BI_ERRORS.getWindow.cover.load,
            biParams: [src],
          },
          {reason},
        );
        this.setState({
          isLoading: false,
          isError: true,
        });
      });
  }

  render() {
    const {accName, children} = this.props;
    const {isLoading, isError} = this.state;
    const {coverSrc, isDummy} = this;
    if (isLoading) {
      return (
        <div className={classNames(styles.cover, styles.coverLoading)}>
          <Loading />
        </div>
      );
    }
    const className = classNames(styles.cover, {
      [styles.coverError]: isError,
      [styles.coverDummy]: isDummy,
    });

    const coverContentClassName = classNames(styles.coverContent, {
      [styles.coverContentError]: isError,
    });

    const style = {
      backgroundImage: !isError && !isDummy ? `url(${coverSrc})` : undefined,
    };

    const coverContentChildrenClassName = classNames(styles.coverContentChildren, {
      [styles.coverContentFallbackImage]: isError,
    });

    return (
      <div className={className} style={style} aria-label={accName} data-hook="cover">
        <div className={styles.undercover} />
        <div className={coverContentClassName} data-hook={isError ? 'coverFallback' : ''}>
          <div className={coverContentChildrenClassName}>{children}</div>
        </div>
      </div>
    );
  }
}
